export default "__VITE_ASSET__DUvAI0MC__"